import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  changeChat,
  createNewChatAsync,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import { Image, LI, P, UL } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";
import { formatDistanceToNow, parse } from "date-fns";
import { getUserID } from "../../../../../../services/helper";
import AddNewFriendModal from "./AddNewFriendModal";
import SideHeader from "../Common/SideHeader";
import ContactEdit from "./ContactEdit";

export default function FriendsTabPane({ changeToChat }) {
  const { members, friends, blocked } = useSelector((state) => state.chat);
  const toggleCreateModal = () => setCreateModalOpen(!createModalOpen);

  const [Contacts, setContacts] = useState([]);
  const [createModalOpen, setCreateModalOpen] = useState(false); // For toggling the create group modal
  const membersWithChats = members.filter(
    (member) => friends.includes(member.id) && !blocked.includes(member.id)
  );

  const groupCustomersByName = (customers) => {
    const groupedData = {};
    customers.forEach((customer) => {
      const firstLetter = customer.name.charAt(0).toUpperCase();
      if (!groupedData[firstLetter]) {
        groupedData[firstLetter] = [];
      }
      groupedData[firstLetter].push(customer);
    });

    const result = Object.keys(groupedData)
      .sort()
      .map((letter) => ({
        title: letter,
        child: groupedData[letter],
      }));

    return result;
  };

  useEffect(() => {
    const grouped = groupCustomersByName(membersWithChats);
    setContacts(grouped);
  }, [members, friends, blocked]);

  return (
    <>
      <SideHeader title="Invite" toggle={toggleCreateModal} />
      {Contacts.length > 0 ? (
        <div className="contact-wrapper">
          {Contacts.map((data, index) => (
            <Fragment key={index}>
              <P>{data.title}</P>
              <UL className="border-0 simple-list">
                {data.child.map((item, index) => (
                  <LI className="common-space" key={index}>
                    <div className="chat-time">
                      {item?.text ? (
                        <div className={`custom-name bg-light-secondary`}>
                          <P className={`txt-secondary f-w-500`}>
                            {item?.text}
                          </P>
                        </div>
                      ) : (
                        <Image
                          className="img-fluid rounded-circle"
                          src={
                            item?.image
                              ? item?.image
                              : dynamicImage("avtar/3.jpg")
                          }
                          alt="user"
                        />
                      )}
                      <div>
                        <span>{item?.name}</span>
                        <P>{item?.store_name}</P>
                      </div>
                    </div>
                    <ContactEdit
                      className={"ml-auto"}
                      id={item?.id}
                      changeToChat={changeToChat}
                    />
                  </LI>
                ))}
              </UL>
            </Fragment>
          ))}
        </div>
      ) : (
        <div className="text-center">{"No User Present"}</div>
      )}
      <AddNewFriendModal isOpen={createModalOpen} toggle={toggleCreateModal} />{" "}
    </>
  );
}
